import { render } from "./empty-inline.vue?vue&type=template&id=5e3f02c1&lang=pug"
import script from "./empty-inline.vue?vue&type=script&lang=js"
export * from "./empty-inline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__